import KeyboardGrid from "./kb-grid.js";

export default class NiceGrid extends KeyboardGrid {
	constructor(...args) {
		super(...args);

		this.undoStack = [this.undoEntry()];
		this.undoPointer = 0; // position in stack of current game state

		this.onUpdate((fromInput) => {
			if (!fromInput) return;
			// Worked example of how the undo numbers work:
			// Here we're adding to the undo stack. The undo pointer is currently 2,
			// but there are 5 entries in the undo stack because there's some redo buffer.
			// stack = [ 0, 1, currentGameState, 3, 4 ]
			// First, discard everything but the first 4 entries,
			this.undoStack.splice(++this.undoPointer);
			// After pushing the new entry,
			this.undoStack.push(this.undoEntry());
			// the stack will have length 5 and the pointer will be 4, which is correct.
			// stack = [ 0, 1, 2, currentGameState ]
		});
	}

	undoEntry() {
		return this.cells.map(row => row.map(cell => [ cell.vWall, cell.hWall ]));
	}

	undo() {
		if (!this.undoPointer) return;
		// Suppose we now undo something.
		// The undo pointer is 3, and the stack has 4 entries:
		// stack = [ 0, 1, target, currentGameState ]
		// We want the pointer to be 2.
		// Entry 3 is not discarded, in case we want to redo later.
		this.apply(this.undoStack[--this.undoPointer]);
		// stack = [ 0, 1, currentGameState, 2 ]
	}

	redo() {
		if (this.undoPointer == this.undoStack.length - 1) return;
		// It is now later.
		// The undo pointer is 2, and the stack has 4 entries:
		// stack = [ 0, 1, currentGameState, 2 ]
		// We want to move the undo pointer to 3 and apply the result.
		this.apply(this.undoStack[++this.undoPointer]);
		// stack = [ 0, 1, 2, currentGameState ]
	}

	apply(entry) {
		for (let y = 0; y < this.cells.length; ++y)
			for (let x = 0; x < this.cells[y].length; ++x)
				[this.cells[y][x].vWall, this.cells[y][x].hWall] = entry[y][x];
		this.update(false);
	}

	removeAllWalls() {
		for (const cell of this.allCells()) cell.vWall = cell.hWall = false;
		this.update(true);
	}
}
